<template>
  <div class="my_comment">
    <!-- <a-spin :spinning="myCommentSpinning">
      <comment
        v-for="item in commentList"
        :key="item.id"
        :comment-data="item"
        :opers="['del']"
        :info="false"
        @onDelete="onDelete"></comment>
      <a-pagination v-show="!myCommentSpinning" v-model="current" :total="total" :defaultPageSize="params.limit" show-less-items />
    </a-spin> -->
    <z-pagination
      desc="暂无评论~"
      :total="total"
      :enptyImage="enptyImage"
      :spinning="myCommentSpinning"
      @loadData="loadData"
    >
      <comment
        v-for="item in commentList"
        :key="item.id"
        :comment-data="item"
        :infoOpers="['del']"
        :info="true"
        @onDelete="onDelete"
      ></comment>
    </z-pagination>
  </div>
</template>
<script>
import zPagination from '@/components/ZPagination'
import comment from '../components/Comment'
import { findMyComments, deleteComment } from '@/api/myQa'
const enptyImage = require('@/assets/course_empty.png')
export default {
  name: '',
  data () {
    return {
      // current: 1,
      myCommentSpinning: false,
      enptyImage,
      params: {
        limit: 10,
        page: 0
      },
      total: 0,
      commentList: []
    }
  },
  watch: {
    // current(val) {
    //   this.params.page = parseInt(val)
    //   this.findMyCommentsAsync(this.params)
    // }
  },
  components: {
    comment,
    zPagination
  },
  created () {
    this.findMyCommentsAsync(this.params)
  },
  methods: {
    loadData (val) {
      this.params.page = parseInt(val) - 1
      this.findMyCommentsAsync(this.params)
    },
    async onDelete ({ id, themeId, userId }) {
      try {
        this.$message.loading({ content: '删除中...', key: 'delete' })
        const res = await deleteComment({
          commentId: id,
          themeId,
          userId
        })
        if (res) {
          this.$message.success({ content: '删除成功', key: 'delete', duration: 2 })
          this.findMyCommentsAsync(this.params)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async findMyCommentsAsync (params) {
      try {
        this.myCommentSpinning = true
        const { commentNum, list } = await findMyComments(params)
        this.total = commentNum
        this.commentList = list
      } catch (error) {
        console.log(error)
      } finally {
        this.myCommentSpinning = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.my_comment {
  padding-bottom: 28px;
  margin-top: -16px;
  .ant-pagination {
    margin-top: 18px;
    text-align: center;
  }
}
</style>
